module.exports = __webpack_public_path__ + "static/media/severe.63a70daf.png";